export default class ProductListingPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.filter = this.dom.querySelector(".filter-wrapper");
    this.DEFAULT_LABEL_CATEGORY_ALL = this.filter.querySelector(
      'button[data-bs-target="#filter-category"] .selection'
    ).textContent;
    this.DEFAULT_LABEL_DESIGNER_ALL = this.filter.querySelector(
      'button[data-bs-target="#filter-designer"] .selection'
    ).textContent;

    let mFilterBtn = this.dom.querySelector(".btn-filter-m");
    mFilterBtn.addEventListener("click", () => {
      this.filter.classList.toggle("expanded");
    });

    this.categoryFilter = this.filter.querySelector("#filter-category");
    if (this.categoryFilter) {
      this.initCategoryFilter();
    }

    this.designerFilter = this.filter.querySelector("#filter-designer");
    if (this.designerFilter) {
      this.initDesignerFilter();
    }

    let btnClear = this.filter.querySelector(".btn-clear");
    btnClear.addEventListener("click", () => {
      this.clearCategoryFilter();
      this.clearDesignerCheckboxes();
    });
    this.sorting = this.dom.querySelector("#product-sorting");
    this.sortingField = this.dom.querySelector("input[name=product_order]");
    this.filter_form = this.dom.querySelector("#filter_form");
    if(this.sorting && this.sortingField && this.filter_form){
      this.sorting.addEventListener("change",()=>{
       let orderValue = this.dom.querySelector("#product-sorting").value;
       this.sortingField.value = orderValue;  
       this.filter_form.submit();

      });
    }
  }

  initCategoryFilter() {
    this.categoryFilter.addEventListener("change", () => {
      let selected = this.categoryFilter.querySelector(
        'input[name="filter-category"]:checked'
      );
      let label = selected.parentNode.querySelector("label").textContent.trim();
      let labelDOM = this.filter.querySelector(
        'button[data-bs-target="#filter-category"] .selection'
      );
      labelDOM.textContent = label;
    });

    this.categoryFilter.dispatchEvent(new Event("change"));
  }

  initDesignerFilter() {
    let input = this.designerFilter.querySelector(".filter-designer-search");
    input.addEventListener("keyup", () => {
      let inputValue = input.value.toUpperCase();
      let designers = this.designerFilter.querySelectorAll(".form-check-label");
      for (let designer of designers) {
        let designerName = designer.textContent;
        if (designerName.toUpperCase().indexOf(inputValue) > -1) {
          designer.parentNode.style.display = "";
        } else {
          designer.parentNode.style.display = "none";
        }
      }
    });

    let checkBoxes = this.designerFilter.querySelectorAll(
      'input[type="checkbox"]'
    );
    for (let checkBox of checkBoxes) {
      checkBox.addEventListener("change", () => {
        let checked = this.designerFilter.querySelectorAll(
          'input[type="checkbox"]:checked'
        );
        let labelDOM = this.filter.querySelector(
          'button[data-bs-target="#filter-designer"] .selection'
        );
        if (checked.length == 1) {
          let label = checked[0].parentNode
            .querySelector("label")
            .textContent.trim();
          labelDOM.textContent = label;
        } else if (checked.length == 0) {
          labelDOM.textContent = this.DEFAULT_LABEL_DESIGNER_ALL;
        } else {
          labelDOM.textContent = `${checked.length} selected`;
        }
      });
    }

    let clearSelection = this.designerFilter.querySelector(
      ".filter-designer-clear"
    );
    clearSelection.addEventListener("click", () => {
      this.clearDesignerCheckboxes();
    });
    
    this.designerFilter.querySelector('input[type="checkbox"]').dispatchEvent(new Event("change"));

  }

  clearCategoryFilter() {
    this.categoryFilter.querySelector(
      'input[name="filter-category"]'
    ).checked = true;
    let labelDOM = this.filter.querySelector(
      'button[data-bs-target="#filter-category"] .selection'
    );
    labelDOM.textContent = this.DEFAULT_LABEL_CATEGORY_ALL;
  }

  clearDesignerCheckboxes() {
    let checkBoxes = this.designerFilter.querySelectorAll(
      'input[type="checkbox"]'
    );
    for (let checkBox of checkBoxes) {
      checkBox.checked = false;
    }
    let labelDOM = this.filter.querySelector(
      'button[data-bs-target="#filter-designer"] .selection'
    );
    labelDOM.textContent = this.DEFAULT_LABEL_DESIGNER_ALL;
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  resize() {}
}
